import React from 'react';

export default function MembershipInfoIcon () {
    return (
<svg width="70" height="70" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="50.998" cy="50" r="48.5" stroke="#807D8E" strokeWidth="3"/>
    <path d="M27.8262 54.0502L44.1079 70.3319C44.4984 70.7224 45.1316 70.7224 45.5221 70.3319L78.4272 37.4268" stroke="#FB2645" strokeWidth="4" strokeLinecap="round"/>
</svg>
);
};